// extracted by mini-css-extract-plugin
export var bounce = "_k0-1";
export var generatingText = "_k0-6";
export var lightning = "_k0-4";
export var popup = "_k0-5";
export var progressBar = "_k0-7";
export var progressFill = "_k0-8";
export var progressShimmer = "_k0-9";
export var progressText = "_k0-a";
export var shimmer = "_k0-3";
export var uploadIcon = "_k0-0";
export var uploadingText = "_k0-2";